export abstract class DataModel {
    id?: string = '';
}
